import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { take } from 'rxjs/operators';
import { DATE_CONST } from './../../../../../../../_shared/constants/date-constants.const';
import { AvailabilityStatus } from './../../../../../../../_shared/enums/treatment/availabilityStatus.enum';
import { TreatmentNote } from './../../../../../../../_shared/model/treatment/treatment-notes.model.';
import { HelperService } from './../../../../../../../_shared/services';
import { Notes } from './../../../../../../../_shared/state/treatment/treatment.actions';

@Component({
    selector: 'trt-wid-m-note-item',
    templateUrl: './trt-wid-m-note-item.component.html',
    styleUrls: ['./trt-wid-m-note-item.component.scss'],
})
export class TrtWidMNoteItemComponent {
    // @Input()
    // set noteData(value: TreatmentNote) {
    //     this.data = _.cloneDeep(value);
    //     if (this.noteItemForm) {
    //         this.createForm();
    //     }
    // }

    @Input()
    noteItemForm: FormGroup;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public dueDatePickerSettings: any = this.helper.getDateSettingsEmpty();

    constructor(
        public store: Store,
        public fb: FormBuilder,
        private helper: HelperService,
    ) {}

    public selectedDate({ start }) {
        this.noteItemForm.controls.eventDate.setValue(start.format(DATE_CONST.format.date.view));

        this.setFormNotChecked();
        // this.formData.markAsTouched();
        // this.formData.markAsDirty()
    }

    get formData() {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <any>this.noteItemForm.controls;
    }

    get formValue() {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <any>this.noteItemForm.value;
    }
    public onSave(): void {
        this.noteItemForm.markAsPristine();
        const value: TreatmentNote = this.noteItemForm.value;
        // value.eventDate = moment(value.eventDate, DATE_CONST.format.date.view);
        value.isDetailsOpend = true;
        this.store
            // .dispatch(new Notes.UpdateNotes([value]))
            .dispatch(new Notes.UpdateNotes([value]))
            .pipe(take(1))
            .subscribe();
    }

    public onFormValueChange(data: TreatmentNote): void {
        this.store.dispatch(new Notes.UpdateNote(data));
    }

    public setFormNotChecked(): void {
        this.formData.availabilityStatus.setValue(AvailabilityStatus.NOT_CHECKED);
    }
}
